import { CompanyDto } from '../../../types';
import { FilterSelect } from '../../../components/shared/FilterSelect';

interface FilterSectionProps {
  companies: CompanyDto[];
  brgs: Array<{ brgId: number; name: string }>;
  selectedCompany: string;
  selectedBrg: number | null;
  onCompanyChange: (company: string) => void;
  onBrgChange: (brgId: number | null) => void;
  onChartTypeChange?: (type: 'bar' | 'pie') => void;
  chartType?: 'bar' | 'pie';
}

export function FilterSection({
  companies,
  brgs,
  selectedCompany,
  selectedBrg,
  onCompanyChange,
  onBrgChange,
  onChartTypeChange,
  chartType = 'pie',
}: FilterSectionProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '16px',
        marginBottom: '24px',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
        <FilterSelect
          label="Company:"
          value={selectedCompany}
          onChange={(e) => onCompanyChange(e.target.value)}
        >
          <option value="All Companies">All Companies</option>
          {companies.map((company) => (
            <option key={company.companyId} value={company.companyName}>
              {company.companyName}
            </option>
          ))}
        </FilterSelect>

        <FilterSelect
          label="BRG:"
          value={selectedBrg ?? ''}
          onChange={(e) => onBrgChange(e.target.value === '' ? null : parseInt(e.target.value, 10))}
        >
          <option value="">All BRGs</option>
          {brgs.map((brg) => (
            <option key={brg.brgId} value={brg.brgId}>
              {brg.name}
            </option>
          ))}
        </FilterSelect>
      </div>

      {/* View Buttons on the Right */}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
        <span style={{ fontSize: '0.85rem', fontWeight: 500, marginRight: '8px', color: '#333' }}>
          View:
        </span>
        <button
          onClick={() => onChartTypeChange?.('bar')}
          style={{
            padding: '8px 16px',
            backgroundColor: chartType === 'bar' ? '#0078d4' : '#f0f0f0',
            color: chartType === 'bar' ? '#fff' : '#333',
            border: chartType === 'bar' ? '1px solid #0078d4' : '1px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: 500,
            transition: 'all 0.2s',
          }}
        >
          Bar Chart
        </button>
        <button
          onClick={() => onChartTypeChange?.('pie')}
          style={{
            padding: '8px 16px',
            backgroundColor: chartType === 'pie' ? '#0078d4' : '#f0f0f0',
            color: chartType === 'pie' ? '#fff' : '#333',
            border: chartType === 'pie' ? '1px solid #0078d4' : '1px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: 500,
            transition: 'all 0.2s',
          }}
        >
          Pie Chart
        </button>
      </div>
    </div>
  );
}
